<template>
  <!-- 全站安全水印：试用租户（TRIAL）访问白名单业务页面时展示，覆盖顶部导航条与路由内容区；登录页、/detail 为独立路由单独接入 -->
  <TmWatermark class="layout-watermark" :show="isWatermarkRoute && isTrialEdition">
  <div v-if="!isNewNav" :class="classObj" class="app-wrapper" :style="{ '--current-color': theme }">
    <template v-if="isSide">
      <side-bar v-if="!sidebar.hide" class="sidebar-container" />
    </template>
    <div class="nav-bar" v-if="isNav">
      <div style="width: 320px; margin-left: 15px">
        <Logo />
      </div>
      <div>
        <navbar ref="navbarRef" @set-layout="setLayout" />
      </div>
    </div>
    <div
      :class="{
        hasTagsView: needTagsView,
        sidebarHide: sidebar.hide,
        mainContainerIsBreadcrumb: !isBreadcrumb,
        mainContainerIsSide: !isSide,
        allHeight: !isNav
      }"
      class="main-container"
    >
      <template v-if="isBreadcrumb">
        <div :class="{ 'fixed-header': fixedHeader }">
          <!-- <tags-view v-if="needTagsView" /> -->
          <breadcrumb v-if="needTagsView" id="breadcrumb-container" class="breadcrumb-container" />
        </div>
      </template>
      <settings ref="settingRef" />
      <app-main />
    </div>
  </div>
  <div v-else class="app-wrapper" :style="{ '--current-color': theme, background: '#131519' }">
    <div class="new_navbar">
      <TopHeader>
        <template #logo>
          <div class="logo_con">
            <div class="logoicon" @click="router.push('/OverallSituation/main')">
              <SvgIcon :icon-class="routeObj?.meta?.icon"></SvgIcon>
            </div>
            <div class="logo_text">
              {{ routeObj?.meta?.title }}
            </div>
          </div>
        </template>
        <template #menu>
          <HorizontalMenu></HorizontalMenu>
        </template>
      </TopHeader>
    </div>
    <div class="route_view">
      <router-view v-slot="{ Component, route }">
        <!-- <transition v-if="!route.meta.noCache" :enter-active-class="animante" mode="out-in"> -->
        <transition v-if="!route.meta.noCache" mode="out-in">
          <div style="width: 100%; height: 100%">
            <keep-alive :include="tagsViewStore.cachedViews">
              <component :is="Component" v-if="!route.meta.link" :key="route.path" />
            </keep-alive>
          </div>
        </transition>
        <!-- <transition v-if="route.meta.noCache" :enter-active-class="animante" mode="out-in"> -->
        <transition v-if="route.meta.noCache" mode="out-in">
          <div style="width: 100%; height: 100%">
            <component :is="Component" v-if="!route.meta.link && route.meta.noCache" :key="route.path" />
          </div>
        </transition>
      </router-view>
    </div>
  </div>
  </TmWatermark>
</template>

<script setup lang="ts">
import useTagsViewStore from '@/store/modules/tagsView';
import SvgIcon from '@/components/SvgIcon/index.vue';
import router from '@/router';
import { watch } from 'vue';
import Logo from './components/Sidebar/Logo.vue';
import SideBar from './components/Sidebar/index.vue';
import { AppMain, Navbar, Settings, TagsView } from './components';
import useAppStore from '@/store/modules/app';
import useSettingsStore from '@/store/modules/settings';
import { useRoute } from 'vue-router';
import { isSideList, isBreadcrumbList, isNavbar, isNewNavBar, WATERMARK_ROUTES } from '@/global/ContentPreview';
import { initWebSocket } from '@/utils/websocket';
import TopHeader from '@/components/header/TopHeader.vue';
import HorizontalMenu from './components/Sidebar/horizontalMenu.vue';
import usePermissionStore from '@/store/modules/permission';
import { isHttp } from '@/utils/validate';
import { constantRoutes } from '@/router';
const permissionStore = usePermissionStore();
// 所有的路由信息
const routers = computed(() => permissionStore.getTopbarRoutes());
// 设置子路由
const childrenMenus = computed(() => {
  let childrenMenus = [];
  routers.value.map((router) => {
    router.children?.forEach((item) => {
      if (item.parentPath === undefined) {
        if (router.path === '/') {
          item.path = '/' + item.path;
        } else {
          if (!isHttp(item.path)) {
            item.path = router.path + '/' + item.path;
          }
        }
        item.parentPath = router.path;
      }
      childrenMenus.push(item);
    });
  });
  return constantRoutes.concat(childrenMenus);
});
const activeRoutes = (key) => {
  let routes = [];
  if (childrenMenus.value && childrenMenus.value.length > 0) {
    childrenMenus.value.map((item) => {
      if (key == item.parentPath || (key == 'index' && '' == item.path)) {
        routes.push(item);
      }
    });
  }
  if (routes.length > 0) {
    permissionStore.setSidebarRouters(routes);
  }
  return routes;
};
const tagsViewStore = useTagsViewStore();
const route = useRoute();
const settingsStore = useSettingsStore();
const theme = computed(() => settingsStore.theme);
const sidebar = computed(() => useAppStore().sidebar);
const device = computed(() => useAppStore().device);
const needTagsView = computed(() => settingsStore.tagsView);
const fixedHeader = computed(() => settingsStore.fixedHeader);

const classObj = computed(() => ({
  hideSidebar: !sidebar.value.opened,
  openSidebar: sidebar.value.opened,
  withoutAnimation: sidebar.value.withoutAnimation,
  mobile: device.value === 'mobile'
}));

const isSide = ref(true);
const isBreadcrumb = ref(true);
const isNav = ref(true);
const isNewNav = ref(false);
// 当前路由是否为需要水印的业务页面；随路由切换更新，控制全局水印层显隐。
const isWatermarkRoute = ref(false);
// 当前租户是否为试用版：登录时由 login 页写入本地存储；登录/重新登录必然重建布局，挂载时读取一次即为最新值。
const isTrialEdition = localStorage.getItem('packageEdition') === 'TRIAL';
const routeObj = ref({});
watch(
  () => route.path,
  (path) => {
    if (isSideList.includes(path)) {
      isSide.value = false;
    } else {
      isSide.value = true;
    }
    if (isBreadcrumbList.includes(path)) {
      isBreadcrumb.value = false;
    } else {
      isBreadcrumb.value = true;
    }
    if (isNavbar.includes(path)) {
      isNav.value = false;
    } else {
      isNav.value = true;
    }
    if (isNewNavBar.includes(path)) {
      isNewNav.value = true;
      if (path) {
        let key = '/' + path.split('/')[1];
        const route = routers.value.find((ite) => ite.path === key);
        routeObj.value = route;
        if (!route || !route.children) {
        } else {
          activeRoutes(key);
        }
      }
    } else {
      isNewNav.value = false;
    }
    // 水印仅覆盖白名单业务页面，其余路由（系统管理、大屏等）不渲染水印。
    isWatermarkRoute.value = WATERMARK_ROUTES.includes(path);
  },
  {
    immediate: true
  }
);

const { width } = useWindowSize();
const WIDTH = 992; // refer to Bootstrap's responsive design

watchEffect(() => {
  if (device.value === 'mobile') {
    useAppStore().closeSideBar({ withoutAnimation: false });
  }
  if (width.value - 1 < WIDTH) {
    useAppStore().toggleDevice('mobile');
    useAppStore().closeSideBar({ withoutAnimation: true });
  } else {
    useAppStore().toggleDevice('desktop');
  }
});

const navbarRef = ref<InstanceType<typeof Navbar>>();
const settingRef = ref<InstanceType<typeof Settings>>();

onMounted(() => {
  let protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
  // initWebSocket(protocol + window.location.host + import.meta.env.VITE_APP_BASE_API + '/resource/websocket');
});

const handleClickOutside = () => {
  useAppStore().closeSideBar({ withoutAnimation: false });
};

const setLayout = () => {
  settingRef.value?.openSetting();
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/mixin.scss';
@import '@/assets/styles/variables.module.scss';

.nav-bar {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  min-width: 810px;
  background-color: rgba(3, 11, 31, 1);
}

/* 水印包装层：撑满高度，保证水印平铺覆盖顶部导航条与路由内容区 */
.layout-watermark {
  height: 100%;
}

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }

  .logo_con {
    margin-left: 20px;
    margin-right: 50px;
    display: flex;
    align-items: center;
    gap: 20px;

    .logoicon {
      width: 40px;
      height: 40px;
      border-radius: 12px;
      background: rgba(13, 131, 252, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 20px;
      cursor: pointer;
      flex-shrink: 0;
    }

    .logo_text {
      font-family: HarmonyOS Sans SC;
      font-size: 22px;
      /* 标题不换行 */
      white-space: nowrap;
    }
  }

  .new_navbar {
    background: #131519;
    height: 80px;
    width: 100vw;
    position: relative;
    z-index: 20;
  }

  .route_view {
    height: calc(100% - 80px);
    width: 100vw;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$base-sidebar-width});
  transition: width 0.28s;
  background: $fixed-header-bg;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.sidebarHide .fixed-header {
  width: 100%;
}

.mobile .fixed-header {
  width: 100%;
}

.mainContainerIsSide {
  width: 100% !important;
  margin: 0 !important;
}

.allHeight {
  top: 0 !important;
  height: 100vh !important;
}
</style>

<style lang="scss">
.mainContainerIsSide {
  .app-main {
    width: 100% !important;
    // transition-duration: 0 !important;
  }
}
</style>
